import React from "react";
import "../../styles/Alumni.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

// Placeholder image
import Placeholder from "../../images/testimonial-1.jpg";

// ------------------ SAMPLE DATA ------------------

const alumniList = [
  {
    name: "Amit Patil",
    position: "Software Engineer",
    company: "TCS",
    year: "Batch 2020",
    img: Placeholder,
  },
  {
    name: "Priya Shinde",
    position: "Data Analyst",
    company: "Infosys",
    year: "Batch 2019",
    img: Placeholder,
  },
  {
    name: "Sagar More",
    position: "Research Intern",
    company: "IIT Bombay",
    year: "Batch 2021",
    img: Placeholder,
  },
];

const testimonials = [
  {
    name: "Rohan Kulkarni",
    text: "My time at the college shaped my career. The faculty support was exceptional.",
    img: Placeholder,
  },
  {
    name: "Sneha Deshmukh",
    text: "The NSS and cultural activities here helped me grow as a leader.",
    img: Placeholder,
  },
];

// -------------------------------------------------

export default function Alumni() {
  return (
    <>
      <Navbar />

      <div className="alumni-page fade-in-page">

        {/* ---------------- HERO ---------------- */}
        <section className="alumni-hero">
          <h1>🎓 Our Alumni</h1>
          <p>
            Meet the proud graduates who are contributing to society and 
            representing our college across the world.
          </p>
        </section>

        {/* ---------------- NOTABLE ALUMNI ---------------- */}
        <section className="alumni-section">
          <h2 className="section-title">🌟 Notable Alumni</h2>

          <div className="alumni-grid">
            {alumniList.map((a, index) => (
              <div className="alumni-card slide-up" key={index}>
                <img src={a.img} alt={a.name} />

                <h3>{a.name}</h3>
                <p className="pos">{a.position}</p>
                <p className="company">{a.company}</p>
                <p className="year">{a.year}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ---------------- TESTIMONIALS ---------------- */}
        <section className="alumni-section">
          <h2 className="section-title">🗣 What Our Alumni Say</h2>

          <div className="testimonial-grid">
            {testimonials.map((t, idx) => (
              <div className="testimonial-card slide-up" key={idx}>
                <img src={t.img} alt={t.name} />
                <p className="text">“{t.text}”</p>
                <h4>- {t.name}</h4>
              </div>
            ))}
          </div>
        </section>

        {/* ---------------- CTA: REGISTER ---------------- */}
        <section className="alumni-register slide-up">
          <h2 className="section-title white-title">📝 Register as Alumni</h2>

          <p>
            Become a part of our Alumni Network and stay connected with 
            college activities, events, and opportunities.
          </p>

          <a
            href="YOUR_GOOGLE_FORM_LINK"
            target="_blank"
            rel="noreferrer"
            className="register-btn"
          >
            Register Now
          </a>
        </section>

        {/* ---------------- GALLERY ---------------- */}
        <section className="alumni-section">
          <h2 className="section-title">📸 Alumni Meet Gallery</h2>

          <div className="gallery-grid-alumni">
            <img src={Placeholder} alt="Gallery" />
            <img src={Placeholder} alt="Gallery" />
            <img src={Placeholder} alt="Gallery" />
            <img src={Placeholder} alt="Gallery" />
          </div>
        </section>

        {/* ---------------- CONTACT ---------------- */}
        <section className="alumni-contact slide-up">
          <h2 className="section-title">📞 Contact Alumni Cell</h2>

          <p><strong>Email:</strong> alumni@mulikadevimahavidyalaya.edu.in</p>
          <p><strong>Phone:</strong> +91 9876543210</p>
        </section>

      </div>

      <Footer />
    </>
  );
}
